import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { ScreenDepthLanding } from "@ryde/utils-landings";

export const StepAnimationStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "animation-page-landings-wrapper",
})`
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  display: flex;
  justify-content: center;
  z-index: ${ScreenDepthLanding.ANIMATION_CONTAINER};
`;
